import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { UpdateInvitacionesAsesoriaCommandProps } from "api/Commands/UpdateInvitacionesAsesoriaCommand"
import {
  ESTADO_INVITACION_ASESORIA,
  EstadoInvitacionAsesoriaType,
} from "api/Types/EstadoInvitacionAsesoria"
import { InvitacionesAsesoriaAdapted } from "common/pages/Dashboard/asesoriasInvitaciones.adapter"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface InvitationsListProps {
  data: InvitacionesAsesoriaAdapted[]
  setStatusAsesorias: ({
    invitaciones,
  }: UpdateInvitacionesAsesoriaCommandProps) => void
  setShowWarningMessage: (arg: boolean) => void
}
const InvitationsList = ({
  data,
  setStatusAsesorias,
  setShowWarningMessage,
}: InvitationsListProps) => {
  const { t } = useTranslation()
  const initialStates = data?.reduce<{ [key: string]: number }>(
    (acc, invitation) => {
      acc[invitation.id] = ESTADO_INVITACION_ASESORIA.PENDIENTE
      return acc
    },
    {}
  )
  const [states, setStates] = useState(initialStates)

  const handleButtonClick = (
    id: string,
    newState: EstadoInvitacionAsesoriaType
  ) => {
    setStates((prev) => {
      let newStates = { ...prev }
      if (newState === ESTADO_INVITACION_ASESORIA.ACEPTADA) {
        newStates = Object.fromEntries(
          Object.entries(newStates).map(([key, value]) =>
            value === ESTADO_INVITACION_ASESORIA.ACEPTADA
              ? [key, ESTADO_INVITACION_ASESORIA.PENDIENTE]
              : [key, value]
          )
        )
      }
      newStates[id] = newState
      return newStates
    })
  }

  useEffect(() => {
    const updatedInvitaciones = Object.keys(states).map((id) => ({
      id,
      estadoInvitacion: states[id],
    }))
    const acceptedNewAsesoria = Object.values(states).includes(
      ESTADO_INVITACION_ASESORIA.ACEPTADA
    )
    setShowWarningMessage(acceptedNewAsesoria)
    // @ts-expect-error TS(2322): Type '{ id: string; estadoInvitacion: number; }[]'...
    setStatusAsesorias({ invitaciones: updatedInvitaciones })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [states, setStatusAsesorias])

  return (
    <>
      <p className='tw-font-medium tw-mb-2'>
        {t("crear.asesoria.modal.invitations")}
      </p>
      <div className='tw-bg-background tw-p-4 tw-h-72 tw-overflow-y-auto'>
        {data?.map((invitation: InvitacionesAsesoriaAdapted) => {
          const stateButtons = invitation?.id && states[invitation?.id]
          return (
            <div
              key={invitation?.id}
              className='tw-bg-simple-10 tw-w-full tw-px-4 tw-py-3 tw-rounded hover:tw-shadow tw-mb-2 tw-grid tw-grid-cols-6'
            >
              <div className='tw-flex tw-items-center tw-justify-center tw-col-span-1 tw-mr-3'>
                {invitation?.logo ? (
                  <img
                    className='tw-h-10 tw-object-contain'
                    alt='logoAsesoriaInvitacion'
                    src={invitation?.logo}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={["fal", "handshake"]}
                    className='tw-self-center tw-w-5 tw-h-5 sm:tw-w-8 sm:tw-h-8 '
                  />
                )}
              </div>
              <div className='tw-flex-col tw-text-left tw-pr-4 tw-col-span-3'>
                <p className='tw-mb-1 tw-h-5 tw-font-medium tw-max-w-72 tw-truncate'>
                  {invitation?.razonSocial}
                </p>
                <p className='tw-mb-0 tw-text-text tw-text-xs'>
                  {invitation?.provinciaRegistroMercantil}
                </p>
              </div>
              <div className='tw-flex tw-col-span-2'>
                {stateButtons === ESTADO_INVITACION_ASESORIA.PENDIENTE ? (
                  <>
                    <ButtonPrimeReact
                      className='!tw-border-0 !tw-px-6 !tw-py-2 !tw-bg-white !tw-text-danger !tw-mr-4 tw-items-center'
                      onClick={() =>
                        handleButtonClick(
                          invitation.id,
                          ESTADO_INVITACION_ASESORIA.RECHAZADA
                        )
                      }
                    >
                      {t("crear.asesoria.modal.rejectButton")}
                    </ButtonPrimeReact>
                    <ButtonPrimeReact
                      className='!tw-border-solid !tw-border-success !tw-px-6 !tw-py-2 tw-text-white !tw-bg-success hover:!tw-bg-success !tw-rounded !tw-leading-3 tw-items-center'
                      onClick={() => {
                        handleButtonClick(
                          invitation.id,
                          ESTADO_INVITACION_ASESORIA.ACEPTADA
                        )
                      }}
                    >
                      {t("crear.asesoria.modal.acceptButton")}
                    </ButtonPrimeReact>
                  </>
                ) : (
                  <>
                    <ButtonPrimeReact
                      className='!tw-border-0 !tw-py-2 !tw-bg-white !tw-text-text-hyperlinks !tw-px-4 !tw-mr-4'
                      onClick={() =>
                        handleButtonClick(
                          invitation.id,
                          ESTADO_INVITACION_ASESORIA.PENDIENTE
                        )
                      }
                    >
                      {t("crear.asesoria.modal.undoButton")}
                    </ButtonPrimeReact>
                    <span
                      className={`${
                        stateButtons === ESTADO_INVITACION_ASESORIA.ACEPTADA
                          ? "tw-bg-success-10 tw-text-success"
                          : "tw-bg-danger-10 tw-text-danger"
                      } tw-w-25 tw-py-1 tw-font-medium tw-flex tw-justify-center tw-items-center tw-rounded tw-leading-3`}
                    >
                      {stateButtons === ESTADO_INVITACION_ASESORIA.ACEPTADA
                        ? t("crear.asesoria.modal.acceptedButton")
                        : t("crear.asesoria.modal.rejectedButton")}
                    </span>
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default InvitationsList
